/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Suspense } from 'react'
import { Button } from '@hashicorp/mds-react'
import s from './style.module.css'

interface RedditOEmbed {
	provider_url: string
	version: string
	title: string
	provider_name: string
	type: string
	html: string
	author_name: string
	height: number
}

export default async function RedditEmbed({ url }) {
	const res = await fetch(`https://www.reddit.com/oembed?url=${url}`, {
		method: 'GET',
	})
	const embedData: RedditOEmbed = await res.json()

	const darkModeHtml = embedData.html.replace(
		'<blockquote ',
		'<blockquote data-embed-theme="dark" ',
	)

	return (
		<div className={s.redditEmbed}>
			<Suspense
				fallback={
					<div className={s.fallback}>
						<Button
							type="button"
							href={url}
							isHrefExternal={true}
							text="Visit Reddit thread"
							icon="external-link"
							iconPosition="trailing"
							color="secondary"
						/>
					</div>
				}
			>
				<div dangerouslySetInnerHTML={{ __html: darkModeHtml }} />
			</Suspense>
		</div>
	)
}
